import {formatStringEndpoint} from 'utils/Api';
import {GET} from 'utils/Http';

import {
  DashboardStatData,
  DashboardTx,
} from 'components/v2/app/dashboard/models';

export const getDashboardStats = (appId: string) => {
  return GET<DashboardStatData>(formatStringEndpoint(`dashboard/${appId}`));
};

export const getDashboardTxs = (appId: string) => {
  return GET<DashboardTx[]>(
    formatStringEndpoint(`dashboard/${appId}/transactions`),
  );
};
